import { type UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Text } from '@/shared/ui';
import type { CreateLaunchFormData } from '../create-launch/schema';
import { FORM_FIELD_LIMITS } from '@/shared/utils/form-field-limits';
import { inputStyle, labelStyle } from '../create-launch/styles';

interface EditLaunchFieldsProps {
  form: UseFormReturn<CreateLaunchFormData>;
}

/**
 * Form body for the edit-launch drawer: name, address, hold TTL.
 */
export function EditLaunchFields({ form }: EditLaunchFieldsProps) {
  const { t } = useTranslation('features/launches');
  const { errors } = form.formState;

  return (
    <div className="flex flex-col gap-[var(--space-4)]">
      <div className="flex flex-col">
        <Text as="label" style={labelStyle}>
          {t('create.name')} <span className="text-[var(--status-error)]">*</span>
        </Text>
        <input {...form.register('name')} placeholder={t('create.namePlaceholder')} maxLength={FORM_FIELD_LIMITS.launchName} style={inputStyle} />
        {errors.name && <span className="text-[length:var(--text-meta)] text-[var(--status-error)] mt-[var(--space-1)]">{errors.name.message}</span>}
      </div>

      <div className="flex flex-col">
        <Text as="label" style={labelStyle}>{t('create.address')}</Text>
        <input {...form.register('address')} placeholder={t('create.addressPlaceholder')} maxLength={FORM_FIELD_LIMITS.launchAddress} style={inputStyle} />
      </div>

      <div className="flex flex-col">
        <Text as="label" style={labelStyle}>{t('create.holdTtlMinutes')}</Text>
        <input
          type="number"
          {...form.register('holdTtlMinutes')}
          placeholder="15"
          min={1}
          max={FORM_FIELD_LIMITS.holdTtlMinutes}
          style={inputStyle}
        />
        {errors.holdTtlMinutes && (
          <span className="text-[length:var(--text-meta)] text-[var(--status-error)] mt-[var(--space-1)]">{errors.holdTtlMinutes.message}</span>
        )}
      </div>
    </div>
  );
}
